import {
  Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, AfterContentChecked, ChangeDetectionStrategy
} from '@angular/core';
import { LookupDataService } from '../services/lookup-data.service';
import { LU_QM_SourceReference } from '../models/luqmsourcereferencemodel';
import { QMManual } from '../models/qmmanual';
import { Observable } from 'rxjs';
import { LU_QM_SpecificationCategory } from '../models/luqmspecificationcategory';
import { StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalButton, StarbaseModalTypes } from 'starbase-modal-dialog';
import { DataDisplayerBase } from '../data-displayer-base';

@Component({
  selector: 'app-qmmanuals-display',
  templateUrl: './qmmanuals-display.component.html',
  styleUrls: ['./qmmanuals-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QmManualsDisplayComponent extends DataDisplayerBase<QMManual> implements OnInit, AfterContentChecked {
  @Input() editable: boolean;
  @Output() removeAction = new EventEmitter<QMManual>();
  @Output() linkClick = new EventEmitter<QMManual>();

  private isLoadingReferences = false;
  private references = [];
  private categories = [];
  constructor(private lookupSvc: LookupDataService,
              private modalSvc: StarbaseModalDialogService,
              private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    for (let i = this.data.length - 1; i >= 0; i--) {
      if (!this.data[i]) {
        this.data.splice(i, 1);
      }
    }
    // ^ filter out null and undefined values (why they would be in here to begin with, I'm not sure)
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  removeItem(manualLink: QMManual) {
    this.enableConfirmRowModal('Are you sure you want to remove this item? This action can\'t be undone.',
                                    'Item removed',
                                    'Item not removed').subscribe(a => {
        if (a) {
          this.removeAction.emit(manualLink);
        }
    });
  }

 enableConfirmRowModal(msg: string, successMsg?: string, errorMsg?: string): Observable<boolean> {
  const m = new Observable<boolean>(obj => {
    const modal = new StarbaseModalOptions('Confirm', msg, [
      new StarbaseModalButton('Yes', () => {
        obj.next(true);
        this.modalSvc.closeModal(successMsg);
      }),
      new StarbaseModalButton('No', () => {
        obj.next(false);
        this.modalSvc.closeModal(errorMsg);
      }),
    ], StarbaseModalTypes.Warning);

    modal.dismissable = true;
    this.modalSvc.postModal(modal);
    });

    return m;
 }

  clickTheLink(qm: QMManual) {
    this.linkClick.emit(qm);
  }

  getLuName(pItem: object, isSourceReference: boolean) {
    if (!pItem) {
      return 'N/A';
    }

    const sourceId = pItem[ (isSourceReference ? 'sourceReferenceUID' : 'specificationCategoryUID')];

    if (!sourceId) {
      return 'N/A';
    }

    const item = (isSourceReference
      ? this.references.find(x => x.sourceReferenceId === sourceId)
      : this.categories.find(x => x.specificationCategoryUID === sourceId));

    if (item) {
      return (isSourceReference ? item.sourceReferenceName : item.specificationCategory );
    } else {
        if (!this.isLoadingReferences) {
          this.isLoadingReferences = true; // TODO: Use the URI getters in teh data service instead of hardcoding here
          let url = '/api/LU_QMSourceReferenceModel/' + sourceId;

          if (!isSourceReference) { // TODO: Do not hardcode URI here
              url = '/api/LU_QMSpecificationCategoryModel/' + sourceId;
          }

          const subsObj = this.lookupSvc.getRequisiteData(url);

          if (isSourceReference) {
              subsObj.subscribe((sourceReference: LU_QM_SourceReference) => {
                  this.references.push({sourceReferenceId: sourceId, sourceReferenceName: sourceReference.sourceReference});
                  return sourceReference.sourceReference;
              },
              () => {},
                () => {
                  this.isLoadingReferences = false;
                });
          } else {
            subsObj.subscribe((specificationCategory: LU_QM_SpecificationCategory) => {
              this.categories.push(
                {
                  specificationCategoryUID: sourceId,
                  specificationCategory: specificationCategory.specificationCategory
                });
              return specificationCategory.specificationCategory;
            },
            () => {},
              () => {
                this.isLoadingReferences = false;
              });
          }
        }

    }
  }

}
